import { render, staticRenderFns } from "./CancelIcon.vue?vue&type=template&id=58e960f2&functional=true&"
import script from "./CancelIcon.vue?vue&type=script&lang=js&"
export * from "./CancelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports